
import axios from "axios";

const API_BASE = "https://assessment.tetekniqx.com/api";

// Axios instance for other endpoints
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
});

// --------------------
// Questions
// --------------------

// Questions filtered by topic
export const getQuestionsByTopic = async (topic) => {
  const res = await axios.get(`${API_BASE}/questions/?topic=${topic}`);
  // backend already returns { questions: [...] }
  return res.data;
};

// --------------------
// Employees
// --------------------
export const getEmployees = async () => {
  const response = await api.get("employees/");
  return response.data;
};

export const addEmployee = async (employeeData) => {
  const response = await api.post("employees/", employeeData);
  return response.data;
};

// --------------------
// Results
// --------------------
export const getResults = async () => {
  const response = await api.get("results/");
  return response.data;
};

export const addResult = async (resultData) => {
  const response = await api.post('results/', resultData);
  return response.data;
};

// --------------------
// Update Employee (PATCH)
// --------------------
export const updateEmployee = async (cid, updateData) => {
  const response = await api.patch(`employees/${cid}/`, updateData);
  return response.data;
};



export default api;